import BaseViewMach from './BaseViewMach';

export default BaseViewMach;
